"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.HeaderImpressionType=void 0;var r;(function(e){e.Gnc="GNC",e.Grc="GRC"})(r||(exports.HeaderImpressionType=r={}));
//# sourceMappingURL=HeaderImpressionType.js.map
